var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
          attrs: { topClass: "topcolor-orange" },
        },
        [
          _c(
            "c-table",
            {
              ref: "RiskTable",
              attrs: {
                title: "LBL0002368",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.grid.data,
                filtering: false,
                isExcelDown: false,
                columnSetting: false,
                usePaging: false,
                hideBottom: true,
                editable: _vm.editable,
                rowKey: "ramRiskAssessmentPlanId",
                selection: "multiple",
              },
              on: { linkClick: _vm.linkClick },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable && !_vm.disabled
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLADD",
                              showLoading: false,
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addRisk },
                          })
                        : _vm._e(),
                      _vm.editable && !_vm.disabled && _vm.grid.data.length > 0
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLEXCEPT",
                              showLoading: false,
                              icon: "remove",
                            },
                            on: { btnClicked: _vm.removeRisk },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }